<template>
  <v-content class="eligibilities page">
    <can I="read" a="Eligibility">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Eligibility', to: '/eligibilities' },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <can I="read" a="Profile">
            <v-tooltip left v-if="filters.profile">
              <v-btn
                flat
                fab
                small
                slot="activator"
                :href="`/profiles/${filters.profile}`"
                target="_blank"
              >
                <v-icon>mdi-account-card-details</v-icon>
              </v-btn>
              <span>View Profile</span>
            </v-tooltip>
          </can>

          <can I="read" a="Opportunity">
            <v-tooltip left v-if="filters.opportunity">
              <v-btn
                flat
                fab
                small
                slot="activator"
                :href="`/opportunities/${filters.opportunity}`"
                target="_blank"
              >
                <v-icon>mdi-worker</v-icon>
              </v-btn>
              <span>View Opportunity</span>
            </v-tooltip>
          </can>
        </v-toolbar>

        <v-card toolbar>
          <v-toolbar flat class="transparent">
            <v-card-title class="headline">Eligibility Check</v-card-title>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="!(filters.profile && filters.opportunity)"
              @click="check"
            >
              Check
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <ProfileSelect clearable v-model="filters.profile" @input="filter" />
            <OpportunitySelect clearable v-model="filters.opportunity" @input="filter" />
          </v-card-text>

          <div v-if="!loading">
            <Eligibility v-if="eligibility" :value="eligibility" />
          </div>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import Eligibility from '@/components/applications/Eligibility'
import OpportunitySelect from '@/components/selects/OpportunitySelect'
import ProfileSelect from '@/components/selects/ProfileSelect'

// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

// Vue Component
export default {
  components: { Eligibility, OpportunitySelect, ProfileSelect },
  created() {
    this.check()
  },
  data() {
    return {
      // Filters
      filters: {
        profile: this.$route.query.profile ? parseInt(this.$route.query.profile) : null,
        opportunity: this.$route.query.opportunity ? parseInt(this.$route.query.opportunity) : null,
      },
      loading: false,
      eligibility: null,
    }
  },
  methods: {
    check() {
      if (this.filters.profile && this.filters.opportunity) {
        this.loading = true
        this.$http
          .get(`admin/eligibility/check/${this.filters.opportunity}/${this.filters.profile}`)
          .then(({ data: { eligibility } }) => (this.eligibility = eligibility))
          .finally(() => (this.loading = false))
      }
    },
    filter(payloadOrEvent) {
      // Update URL
      const filters = Object.assign({}, this.filters)
      this.$router.replace(Object.assign({}, this.$route, { query: _.pickBy(filters, _.identity) }))
    },
  },
}
</script>
